<div class="container-main">
  <nav class="navbar navbar-expand-lg navbar-light">
    <a class="navbar-brand" (click)="goToPage('inicio')"><img class="image-header" src="../assets/logo_circular.png"></a>
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse justify-content-center" id="navbarNavDropdown">
      <ul class="navbar-nav">
        <li class="nav-item">
          <a class="nav-submenu" [ngStyle]="{'border-bottom':borderHome}" (click)="goToPage('inicio')">Inicio</a>
        </li>
        <li class="nav-item">
          <a class="nav-submenu" [ngStyle]="{'border-bottom':borderAbout}" (click)="goToPage('sobre-mi')">Sobre mí</a>
        </li>
        <li class="nav-item">
          <a class="nav-submenu" [ngStyle]="{'border-bottom':borderLine}" (click)="goToPage('aprendizaje')">Linea de Aprendizaje</a>
        </li>
        <li class="nav-item">
          <a class="nav-submenu" [ngStyle]="{'border-bottom':borderContact}" (click)="goToPage('contacto')">Contacto</a>
        </li>
      </ul>
    </div>
  </nav>
</div>